import phoneFormats from '../data/formats.json.js';
import phonePatterns from '../data/patterns.json.js';

/** ---------------------------------------------------------------------------------------
 * getCountryFromNumber
 *
 * @param {number} number - The number used for country matching
 *
 */
const getCountryFromNumber = (number) => {
  const parsedNumber = number.replace(/^\+/, '');

  if (parsedNumber.length < 11) {
    console.warn(`intl-phone cannot determine country for ${number}`);
    return null;
  }

  const matchedCountries = Object.values(phoneFormats)
    .filter(({countryCode}) => parsedNumber.startsWith(countryCode))
    .map((entry) => entry.country);

  // Narrow down to actual matched country
  for (const country of matchedCountries) {
    const countryData = phoneFormats[country];
    if (countryData && phonePatterns[country]) {
      const {countryCode} = countryData;
      // Remove matched country code: "+13139205555" --> "3139205555"
      const remainingNumber = parsedNumber.slice(countryCode.length);
      const countryPatterns = phonePatterns[country];

      for (const [patternName, pattern] of Object.entries(countryPatterns)) {
        if (patternName === 'national') {
          continue;
        }

        const regex = new RegExp(`^${pattern}$`);

        if (regex.test(remainingNumber)) {
          return country;
        }
      }
    }
  }

  console.warn(`intl-phone cannot determine country for ${number}`);
  return null;
};

export { getCountryFromNumber };
